const RENTALS_AUTH = {
  //getPackages
  RENTALS_PACKAGES: 'RENTALS_PACKAGES',
  //confirmUserRegistration
  RENTALS_USER_REGISTRATION: 'RENTALS_USER_REGISTRATION',
};

export default RENTALS_AUTH;
